document.querySelectorAll('[data-quantity]').forEach(button=>button.addEventListener('click',()=>{
  const input=button.closest('.quantity').querySelector('input');
  const step=Number(input.step)||1;
  const minimum=Number(input.min)||1;
  const maximum=input.max?Number(input.max):Infinity;
  input.value=String(Math.max(minimum,Math.min(maximum,(Number(input.value)||minimum)+Number(button.dataset.quantity)*step)));
  input.dispatchEvent(new Event('change',{bubbles:true}));
}));
document.querySelector('[data-variant-select]')?.addEventListener('change',event=>{
  const url=new URL(location.href);url.searchParams.set('variant',event.target.value);location.assign(url.href);
});
const dialog=document.getElementById('PosterImageDialog');
document.querySelector('.zoom-image')?.addEventListener('click',()=>dialog?.showModal());
document.querySelector('[data-close-image]')?.addEventListener('click',()=>dialog?.close());
dialog?.addEventListener('click',event=>{if(event.target===dialog)dialog.close()});
document.querySelectorAll('[data-gallery-image]').forEach(button=>button.addEventListener('click',()=>{
  for(const image of [document.querySelector('.product-photo'),dialog?.querySelector('img')]){
    if(!image)continue;image.removeAttribute('srcset');image.src=button.dataset.galleryImage;image.alt=button.dataset.imageAlt;
  }
}));
